<template>
    <div class="family-patents-loading">
        <div
            v-for="item in 3"
            :key="item"
            class="pa-p-4"
        >
            <div class="pa-flex">
                <span class="pa-bg-gray-30 pa-rounded pa-h-4 pa-mr-2 pa-w-4" />
                <span class="pa-bg-gray-30 pa-rounded pa-h-4 pa-w-[160px]" />
            </div>
            <div
                v-if="!isFamilySearchFromWorkspace"
                class="pa-flex pa-mt-2"
            >
                <span class="pa-bg-gray-30 pa-rounded pa-h-4 pa-mr-2 pa-w-[48px]" />
                <span class="pa-bg-gray-30 pa-rounded pa-h-4 pa-mr-2 pa-w-[48px]" />
                <span class="pa-bg-gray-30 pa-rounded pa-h-4 pa-mr-2 pa-w-[48px]" />
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import { useFamilySearch } from '@/composables/use-family-search';

const { isFamilySearchFromWorkspace } = useFamilySearch();
</script>
<style lang="scss">

</style>
